import { render, staticRenderFns } from "./student-opportunities.vue?vue&type=template&id=7597ac20&scoped=true&"
import script from "./student-opportunities.vue?vue&type=script&lang=js&"
export * from "./student-opportunities.vue?vue&type=script&lang=js&"
import style0 from "./student-opportunities.vue?vue&type=style&index=0&id=7597ac20&scoped=true&lang=css&"
import style1 from "./student-opportunities.vue?vue&type=style&index=1&id=7597ac20&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7597ac20",
  null
  
)

component.options.__file = "student-opportunities.vue"
export default component.exports